'use strict'

import http from './http-common'
import authHeader from './auth-header'
import useSWR from 'swr'

const getAll = (customerId) => {
  return http.axiosClient.get(`/customers/${customerId}/documents`, {
    headers: authHeader()
  })
}

const get = (customerId, id) => {
  return http.axiosClient.get(`/customers/${customerId}/documents/${id}`, {
    headers: authHeader()
  })
}

const create = (customerId, data) => {
  return http.axiosClient.post(`/customers/${customerId}/documents`, data, {
    headers: authHeader()
  })
}

const update = (customerId, id, data) => {
  return http.axiosClient.put(`/customers/${customerId}/documents/${id}`, data, {
    headers: authHeader()
  })
}

const remove = (customerId, id) => {
  return http.axiosClient.delete(`/customers/${customerId}/documents/${id}`, {
    headers: authHeader()
  })
}

export default {
  getAll,
  get,
  create,
  update,
  remove,
}
